// A restroom's own image (imageURL from the config). Restrooms without one show no icon,
// and an image that fails to load is hidden.
import React from 'react';

const RestroomIcon = ({ imageURL, className = '' }) => {
  if (!imageURL) return null;
  return (
    <span className={`fx-icon ${className}`} aria-hidden="true">
      <img
        src={imageURL}
        alt=""
        onError={(e) => { e.currentTarget.parentElement.style.display = 'none'; }}
      />
    </span>
  );
};

export default RestroomIcon;
